import React, { useMemo } from 'react';
import './TopHeader.scss';
import LanguageSelector from './LanguageSelector';
import TopHeaderItem from './TopHeaderItem';

function TopHeaderBusiness({
  showChangeLanguageButton,
  linkLangMap,
  langCode,
  menuTopHeaderBusiness,
}) {
  const menuLeft =
    menuTopHeaderBusiness?.leftSectionBusiness?.content?.labelLinkBusinessLeft;
  const menuRight =
    menuTopHeaderBusiness?.rightSectionBusiness?.content
      ?.labelLinkBusinessRight;

  const linkLeft = useMemo(
    () =>
      menuLeft?.filter(
        (item) =>
          (item?.value ||
            item.content?.linkExternalBusinessLeft?.value ||
            item.content?.linkInternalBusinessLeft?.value?.link) &&
          !item.content?.linkNotVisibleBusinessLeft?.value
      ),
    [menuLeft]
  );
  const linkRight = useMemo(
    () =>
      menuRight?.filter(
        (item) =>
          (item?.value ||
            item.content?.linkExternalBusinessRight?.value ||
            item.content?.linkInternalBusinessRight?.value?.link) &&
          !item.content?.linkNotVisibleBusinessRight?.value
      ),
    [menuRight]
  );

  return (
    <>
      <div className='top-header-section top-header-section--left'>
        <ul className='top-header-list'>
          {linkLeft?.map(
            (item) =>
              (item?.value ||
                item.content.iconSvgIdBusinessLeft?.value ||
                item.content.linkInternalBusinessLeft?.value?.pageTitle
                  ?.value ||
                item.content.linkExternalBusinessLeft.value) && (
                <TopHeaderItem
                  labelItem={item.value}
                  iconItem={item.content.iconSvgIdBusinessLeft.value}
                  iconThickness={
                    item?.content?.iconSvgIdBusinessLeft?.content
                      ?.iconThicknessLeft?.value?.[0]
                  }
                  checkIconItem={item.content.checkIconBusinessLeft.value}
                  pageTitleItem={
                    item.content.linkInternalBusinessLeft?.value?.pageTitle
                      ?.value
                  }
                  internalLinkItem={
                    item.content.linkInternalBusinessLeft?.value?.link
                  }
                  externalLinkItem={item.content.linkExternalBusinessLeft.value}
                  linkAsButton={item.content.linkAsButtonBusinessLeft.value}
                  key={item.value}
                />
              )
          )}
        </ul>
      </div>
      <div className='top-header-section top-header-section--right'>
        <ul className='top-header-list'>
          {linkRight?.map(
            (item) =>
              (item?.value ||
                item.content.iconSvgIdBusinessRight?.value ||
                item.content.linkInternalBusinessRight?.value?.pageTitle
                  ?.value ||
                item.content.linkExternalBusinessRight.va) && (
                <TopHeaderItem
                  labelItem={item.value}
                  iconItem={item.content.iconSvgIdBusinessRight.value}
                  iconThickness={
                    item?.content?.iconSvgIdBusinessRight?.content
                      ?.iconThicknessRight?.value?.[0]
                  }
                  checkIconItem={item.content.checkIconBusinessRight.value}
                  pageTitleItem={
                    item.content.linkInternalBusinessRight?.value?.pageTitle
                      ?.value
                  }
                  internalLinkItem={
                    item.content.linkInternalBusinessRight?.value?.link
                  }
                  externalLinkItem={
                    item.content.linkExternalBusinessRight.value
                  }
                  linkAsButton={item.content.linkAsButtonBusinessRight.value}
                  key={item.value}
                />
              )
          )}
        </ul>
        {showChangeLanguageButton && (
          <LanguageSelector
            linkLangMap={linkLangMap}
            langCode={langCode}
            className={'top-header-language'}
          />
        )}
      </div>
    </>
  );
}

export default TopHeaderBusiness;
